"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
var _CommandError = require('shared/log/CommandError');

 const passError = (cb) => (e) => {
  cb(e)
  throw e
}; exports.passError = passError

 const isWSError = (e) =>
  !!e && !(e instanceof Error); exports.isWSError = isWSError

// wsCommand rejects with a CommandError carrying the server's reply.
 const isUnauthorizedError = (e) =>
  e instanceof _CommandError.CommandError
    ? _optionalChain([e, 'access', _ => _.extra, 'optionalAccess', _2 => _2.Status]) === 'unauthorized'
    : exports.isWSError.call(void 0, e) && e.Status === 'unauthorized'; exports.isUnauthorizedError = isUnauthorizedError
